import Vue from 'vue'
import state from 'lib/appState'

export default el => new Vue({
  el,
  data () {
    return {
      state
    }
  },
  computed: {
    getpdpUsVsTheme () {
      if (Object.keys(this.state.activeProduct).length) {
        return this.state.activeProduct.pdpUsVsTheme
      }
    },
    heading () {
      if (Object.keys(this.getpdpUsVsTheme).length) {
        return this.getpdpUsVsTheme.heading
      }
    },
    features () {
      if (Object.keys(this.getpdpUsVsTheme).length) {
        return this.getpdpUsVsTheme.usFeatures
      }
    },
    themeFeatures () {
      if (Object.keys(this.getpdpUsVsTheme).length) {
        return this.getpdpUsVsTheme.themeFeatures
      }
    },
    list () {
      if (this.features.length) {
        return this.features.map((item, i) => Object.assign({}, item, this.themeFeatures[i]))
      }
    },
    image () {
      if (Object.keys(this.getpdpUsVsTheme).length) {
        return this.getpdpUsVsTheme.image
      }
    }
  }
})
